import React from "react";
import {Modal} from "react-bootstrap";
import {X} from "lucide-react";
import IconButton from "@components/Button/IconButton";

// nco-modal header + divider: optional icon tile, title/subtitle, extra controls (children) and a close button.
export default function NcoModalHeader({icon, danger = false, title, titleId, subtitle, onClose, children}) {
    return (
        <>
            <Modal.Header className="nco-modal-header">
                {icon && <div className={danger ? "nco-head-icon is-danger" : "nco-head-icon"}>{icon}</div>}
                <div className="nco-head-text">
                    <h2 className="nco-head-title" id={titleId}>{title}</h2>
                    {subtitle && <p className="nco-head-sub">{subtitle}</p>}
                </div>
                {children}
                {onClose && <IconButton icon={<X size={18}/>} label="Close" onClick={onClose}/>}
            </Modal.Header>
            <hr className="nco-divider"/>
        </>
    );
}
